import type { INamedPerson } from './person.interface'

export const formatNamedPersonGivenNames = (namedPerson: INamedPerson) =>
  namedPerson.givenNames ? namedPerson.givenNames : undefined

export const formatNamedPersonFullName = (namedPerson: INamedPerson) => {
  const parts = [
    namedPerson.familyName,
    formatNamedPersonGivenNames(namedPerson),
  ].filter((p) => !!p)
  return parts.length > 0 ? parts.join(', ') : null
}
